import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { ACCOUNT } = ANALYTICS_CATEGORIES;
const { HOVER } = SNOWPLOW_EVENTS;

export const triggerPurchasesCompleteSellerMessagingButtonHoveredEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: ACCOUNT.complete,
		name: 'dlr_purchases_complete_seller_messaging_button_hovered',
		schemaName: HOVER.SCHEMA,
		version: HOVER.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
